import { Typography } from "@mui/material";

export const CounterpartyNotesTab = ({ notes }: { notes?: string | null }) => {
    return (
        <Typography variant="body2">
            {notes?.trim() ? notes : "—"}
        </Typography>
    );
};